import type { Components, Theme } from '@mui/material/styles';

const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    /**
     * Корневые стили радиокнопки.
     *
     * MUI даёт 42×42 (padding 9 + иконка 24) — двух пикселей не хватало до
     * тач-минимума 44. Ниже md добираем паддингом; от md значение прежнее.
     *
     * Медиазапрос здесь безопасен: `padding` у `MuiRadio` не выставляет ни один
     * консьюмер (все вызовы — `<Radio />` без sx, проверено грепом), поэтому
     * перебить безусловное объявление из `sx` этот `@media` не может.
     * @param root0 Пропсы
     * @param root0.theme Тема
     */
    root: ({ theme }) => ({
      [theme.breakpoints.down('md')]: {
        padding: 10
      }
    })
  }
};

export const radio = {
  MuiRadio
};
